// extracted by mini-css-extract-plugin
export default {"infoCopy":"gIEHAh8RFiy4WpxvljY_","info":"JhqPTNL8H0zci5nb70sZ","copyButtonWrapper":"SIjJAIbn9a_NR9ezca9R"};